// @ts-nocheck
import UserApi from "./UserApi";
import { mockUser } from "./MockUserData";
class MockUserApi implements UserApi {
  mUser = mockUser;

  //create/update user based on phonenumber
  saveUserDetails = (user: any): Promise<any> => {

    return new Promise(resolve => 
      setTimeout(() => resolve({ success: true }), 1000)
      );
  }
  saveUserProfile = (user: any): Promise<any> => {

    for (const key in user) {
      if (this.mUser.hasOwnProperty(key)) {
        this.mUser[key] = user[key];
      }
    }

    if (user.personal_id_code && user.personal_id_code.length > 0) {
      this.mUser.personalIdCodeRecorded = true;
      this.mUser.noPersonalIdCode = false;      
    }

    return new Promise(resolve => setTimeout(() => resolve(this.mUser), 1000));
  };

  applyUserCoupon = (coupon: string): Promise<any> => {
    return new Promise(resolve => setTimeout(() => resolve({ added: 1000 })));
  };

  savePhoto = (url: string, method: string, imageData: string) => {
    return new Promise(resolve =>
      setTimeout(() => resolve({ success: true }), 1000)
    );
  };

  fetchUser = (): Promise<any> => {
    return new Promise(resolve => setTimeout(() => resolve(this.mUser), 1000));
  };

  fetchUserHash = (token?: string, jwt?: string) => {
    return new Promise(resolve => setTimeout(() => resolve({hash:"fc58836cccfafa9600e9b5ae5cc154808409d831",id:"149239"}), 1000));
  };

  fetchUserPhoto = (): Promise<any> => {
    return new Promise(resolve =>
      setTimeout(() => resolve("MockUserPhotoData"), 1000)
    );
  };

  fetchLicensePhoto = (): Promise<any> => {
    return new Promise(resolve =>
      setTimeout(() => resolve("MockLicensePhotoData"), 1000)
    );
  };

  sendPictureForUser = (
    customerId: number,
    reservationId: number,
    token: string,
    imageData: string
  ): Promise<any> => {
    this.mUser.selfieRecorded = true;
    this.mUser.selfieRejected = false;
    return new Promise(resolve =>
      setTimeout(() => resolve("MockUserPhotoData"), 1000)
    );
  };

  sendPictureForLicense = (
    customerId: number,
    reservationId: number,
    token: string,
    imageData: string
  ): Promise<any> => {
    this.mUser.driversLicenseRecorded = true;
    this.mUser.driversLicenseRejected = false;
    return new Promise(resolve =>
      setTimeout(() => resolve("MockLicensePhotoData"), 1000)
    );
  };

   getPictureStatusForUser = (minutes?: number): Promise<any> => {
    return new Promise((resolve, reject) =>
      setTimeout(() => reject("Not implemented in mock"), 1000)
    );
  };

  sendVerificationEmail = (): Promise<any> => {
    this.mUser.emailReceiveVerified = true;
    return new Promise(resolve =>
      setTimeout(() => resolve("EmailVerify"), 1000)
    );
  };
  
  getVerificationLink = () => {
    //const fetchUrl = `/customers/me/identity-verification-link`;

    return new Promise(resolve =>
      setTimeout(() => resolve({verificationLink:"https://identify.nordea.com/?client_id=O25Yq8eIEgSJkZou45xX&redirect_uri=https%3A%2F%2Fstage-api.24rent.fi%2Fv3%2Fexternal-callback%2Findentification&response_type=code&state=149239_90697b98&nonce=lrslLcSkIGCzpBwsmNayP4BA3OVzs8cJvfA8dhyzrCl7reJp5Uq5o0pTjNQyruXf&scope=openid+ftn_hetu&acr_values=http%3A%2F%2Fftn.ficora.fi%2F2017%2Floa2&ui_locales=en"}), 1000)
    );
  };
}

export default MockUserApi;
